import hasOwnProp from './has-own-prop';

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

export { keys as default };



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/keys.js
// module id = 279
// module chunks = 0